import swal from "sweetalert";
import axiosInstance from "../api";
import { setGetPartnerListData, setGetSinglePartner } from "../booking/bookingSlice";


export const getPartnershipListData = (data) => async (dispatch) => {
    try {
      const response = await axiosInstance.get("admin/drivers", { params: data });
      console.log(response,"response")
      if (response?.data) {
        dispatch(setGetPartnerListData(response?.data?.response))
      } else {
        dispatch(setGetPartnerListData([]))
      }
    } catch (err) {
     // console.error(err);
      dispatch(setGetPartnerListData([]))
    }
  };

  export const addPartnerMembershipData = (data, navigate, setLoading) => async (dispatch) => {
    setLoading(true);
    try {
      const response = await axiosInstance.post("admin/drivers", data);
      if (response?.data?.status) {
        swal({
          text: response?.data?.response?.message,
          icon: "success",
          button: "Close",
          timer: 1500,
        });
        navigate("/partner")
        // return response;
      }
      else{
        swal({
          text: response?.data?.message,
          icon: "error",
          button: "Close",
          timer: 1500,
        });
      }
  
    } catch (err) {
     // console.error(err);
    } finally {
      setLoading(false);
    }
  };


  export const getSinglePartnerMebershipIdData = (id) => async (dispatch) => {
    try {
      const response = await axiosInstance.get(`admin/drivers/${id}`);
      console.log(response,"response")
      if (response?.data) {
        dispatch(setGetSinglePartner(response?.data?.response))
      } else {
        dispatch(setGetSinglePartner([]))
      }
    } catch (err) {
     // console.error(err);
      dispatch(setGetSinglePartner([]))
    }
  };

  export const updatePartnerMembershipData = (data, setLoading,navigate) => async (dispatch) => {
    setLoading(true);
    try {
      const response = await axiosInstance.put("admin/drivers", data);
      if (response?.data?.status) {
        swal({
          text: response?.data?.response?.message,
          icon: "success",
          button: "Close",
          timer: 1500,
        });
        navigate("/partner")
      }
      else{
        swal({
          text: response?.data?.message,
          icon: "error",
          button: "Close",
          timer: 1500,
        });
      }
  
    } catch (err) {
     // console.error(err);
    } finally {
      setLoading(false);
    }
  };

  export const deleteOnePartnerMembershipData = (id) => async (dispatch) => {
    // setLoading(true);
    try {
      const response = await axiosInstance.delete(`admin/drivers/${id}`);
      if (response?.data?.status) {
        swal({
          text: response?.data?.response?.message,
          icon: "success",
          button: "Close",
          timer: 1500,
        });
        window.location.reload();
        // navigate("/membership")
      }
      else{
        swal({
          text: response?.data?.message,
          icon: "error",
          button: "Close",
          timer: 1500,
        });
      }
  
    } catch (err) {
     // console.error(err);
    } finally {
      // setLoading(false);
    }
  };

  export const ChangeDriverData = (data) => async (dispatch) => {
    try {
      const response = await axiosInstance.patch("admin/orders/status", data);
      if (response?.data?.status) {
        swal({
          text: response?.data?.response?.message,
          icon: "success",
          button: "Close",
          timer: 1500,
        });
        window.location.reload();
        // navigate("/partner")
        // return response;
      }
      else{
        swal({
          text: response?.data?.message,
          icon: "error",
          button: "Close",
          timer: 1500,
        });
      }
  
    } catch (err) {
     // console.error(err);
    } finally {
    }
  };